<template>
    <div class="card card-custom">
        <div class="card-header">
            <h3 class="card-title">
                <button class="btn btn-default btn-xs" v-on:click="addnew()">+Add new</button>
            </h3>
        </div>
        <div class="card-body">
            <div class="row">

                <div class="col-md-12">

                    <table class=" table table-bordered table-sm" id="bs4-table">
                        <thead class="bg-custom">
                            <tr>
                                <th>Sr.</th>
                                <th>Category</th>
                                <th>Feedback</th>
                                <th>Response</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,index) in lst">
                                <td>{{index + 1}}</td>
                                <td>{{item.Category}}</td>
                                <td>{{item.Feedback}}</td>
                                <td>{{item.Response}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>import axios from 'axios';
    export default {
        name: 'fee',
        data() {
            return {
                lst: [],
            }
        },
        created() {
            this.pageload();
        },
        updated() {
            $('#bs4-table').DataTable();
        },

        methods: {
            pageload: function () {
                startReq();
                var vm = this;
                axios.post('/api/PortalApi/pageloadGeneralFeedbackList')
                    .then(function (response) {
                        endReq();
                        vm.lst = response.data.lst;
                    })
            },

            addnew() {
                window.location.href = "../Portal/GeneralFeedbackForm";
            },
        }
    }</script>



// WEBPACK FOOTER //
// src/components/school/LMS/generalFeedbackList.vue